import { FC, memo } from 'react'
import { SpotRecentTrades } from '../Trade'
import { OrderBookWrap } from './style'
import { SpotOrderbook } from './Orderbook'

export const OrderList: FC = memo(() => {
  return (
    <OrderBookWrap id="zk_order_book">
      <SpotOrderbook />
      <SpotRecentTrades />
    </OrderBookWrap>
  )
})
